import { memo } from "react";
import { Marker } from "react-map-gl/mapbox";
import { AddressMarkerProps } from "@/components/map/address-marker/types/address-marker-props.type";
import { AddressPinIcon } from "@/components/icons";

export const AddressMarker = memo(({ position, iconColor }: AddressMarkerProps) => {
  return (
    <Marker anchor="bottom" longitude={position[0]} latitude={position[1]}>
      <AddressPinIcon width={20} height={30} color={iconColor} />
    </Marker>
  );
});
